enum PermissoesPadrao {
    UsuarioReadAll = 'UsuarioReadAll',
    UsuarioRead = 'UsuarioRead',
    UsuarioCreate = 'UsuarioCreate',
    UsuarioUpdate = 'UsuarioUpdate',
    UsuarioDelete = 'UsuarioDelete',

    ProfileUpdate = 'ProfileUpdate',

    ClinicaRead = 'ClinicaRead',
    ClinicaUpdate = 'ClinicaUpdate',

    PacienteReadAll = 'PacienteReadAll',
    PacienteRead = 'PacienteRead',
    PacienteCreate = 'PacienteCreate',
    PacienteUpdate = 'PacienteUpdate',
    PacienteDelete = 'PacienteDelete',

    RoleReadAll = 'RoleReadAll',
    RoleRead = 'RoleRead',
    RoleCreate = 'RoleCreate',
    RoleUpdate = 'RoleUpdate',
    RoleDelete = 'RoleDelete',

    AgendaUpdate = 'AgendaUpdate',
    AgendaCreate = 'AgendaCreate',
    AgendaRead = 'AgendaRead',
    AgendaDelete = 'AgendaDelete',
    AgendaReadAll = 'AgendaReadAll',

    AgendamentoRead = 'AgendamentoRead',
    AgendamentoCreate = 'AgendamentoCreate',
    AgendamentoUpdate = 'AgendamentoUpdate',
    AgendamentoDelete = 'AgendamentoDelete',

    ConvenioReadAll= 'ConvenioReadAll',
    ConvenioRead = 'ConvenioRead',
    ConvenioCreate = 'ConvenioCreate',
    ConvenioUpdate = 'ConvenioUpdate',
    ConvenioDelete = 'ConvenioDelete',

    TenantReadAll = 'TenantReadAll',
    TenantRead = 'TenantRead',
    TenantCreate = 'TenantCreate',
    TenantUpdate = 'TenantUpdate',
    TenantDelete = 'TenantDelete',
    TenantPatch = 'TenantPatch',

    SalaDeEsperaRead = 'SalaDeEsperaRead',

    AtendimentoReadAll= 'AtendimentoReadAll',
    AtendimentoRead = 'AtendimentoRead',
    AtendimentoCreate = 'AtendimentoCreate',
    AtendimentoUpdate = 'AtendimentoUpdate',
    AtendimentoDelete = 'AtendimentoDelete',

    ModeloReadAll= 'ModeloReadAll',
    ModeloRead = 'ModeloRead',
    ModeloCreate = 'ModeloCreate',
    ModeloUpdate = 'ModeloUpdate',
    ModeloDelete = 'ModeloDelete',

    AuditoriaReadAll = 'AuditoriaReadAll',
    AuditoriaRead = 'AuditoriaRead',

    AcessoTriagem = 'AcessoTriagem',
    TriagemReadAll = 'TriagemReadAll',
    TriagemRead = 'TriagemRead',
    TriagemCreate = 'TriagemCreate',
    TriagemUpdate = 'TriagemUpdate',
    TriagemDelete = 'TriagemDelete',

    ImpressoPersonalizadoReadAll = 'ImpressoPersonalizadoReadAll',
    ImpressoPersonalizadoRead = 'ImpressoPersonalizadoRead',
    ImpressoPersonalizadoCreate = 'ImpressoPersonalizadoCreate',
    ImpressoPersonalizadoUpdate = 'ImpressoPersonalizadoUpdate',
    ImpressoPersonalizadoDelete = 'ImpressoPersonalizadoDelete',
    AcessoConfiguracaoCampos = 'AcessoConfiguracaoCampos',
    ConfiguracaoCamposReadAll = 'ConfiguracaoCamposReadAll',
    ConfiguracaoCamposRead = 'ConfiguracaoCamposRead',
    ConfiguracaoCamposCreate = 'ConfiguracaoCamposCreate',
    ConfiguracaoCamposUpdate = 'ConfiguracaoCamposUpdate',
    ConfiguracaoCamposDelete = 'ConfiguracaoCamposDelete',

    AcessoImportacaoPlanilha = 'AcessoImportacaoPlanilha',
    ImportacaoPlanilhaReadAll = 'ImportacaoPlanilhaReadAll',
    ImportacaoPlanilhaRead = 'ImportacaoPlanilhaRead',
    ImportacaoPlanilhaCreate = 'ImportacaoPlanilhaCreate',
    ImportacaoPlanilhaUpdate = 'ImportacaoPlanilhaUpdate',
    ImportacaoPlanilhaDelete = 'ImportacaoPlanilhaDelete',

    AcessoCampanhas = 'AcessoCampanhas',

    AcessoMemed = 'AcessoMemed',

    AcessoSumarioLongitudinal = 'AcessoSumarioLongitudinal',
    AcessoCidAuto = 'AcessoCidAuto',
    AcessoScribe = 'AcessoScribe',
    AcessoDrugInteraction = 'AcessoDrugInteraction',
    AcessoCarePathways = 'AcessoCarePathways',
    AcessoBuscaGlobal = 'AcessoBuscaGlobal',
    AcessoCartaEncaminhamento = 'AcessoCartaEncaminhamento',
    AcessoScoresRisco = 'AcessoScoresRisco',
    AcessoNoShowPrediction = 'AcessoNoShowPrediction',

    AcessoPacienteSumido = 'AcessoPacienteSumido',

    WhatsAppEnviarMensagens = 'WhatsAppEnviarMensagens',
    WhatsAppConfigurarInstancia = 'WhatsAppConfigurarInstancia',
    // Onda4 — comunicação/engajamento (gated por WhatsAppAtiva)
    ComunicacaoEnvioRead = 'ComunicacaoEnvioRead',
    LembreteGerenciar = 'LembreteGerenciar',
    NpsRead = 'NpsRead',
    // Onda5 — BI avançado + clínica
    BiAvancadoRead = 'BiAvancadoRead',
    ExameTendenciaRead = 'ExameTendenciaRead',
    ReconciliacaoMedicamentosaRead = 'ReconciliacaoMedicamentosaRead',
    // Onda6 — Segurança & Paciente
    CompartilharProntuarioGerenciar = 'CompartilharProntuarioGerenciar',
    AdesaoTratamentoRead = 'AdesaoTratamentoRead',
    AnamneseRead = 'AnamneseRead',
    AnamneseGerenciar = 'AnamneseGerenciar',

    TelemedicinaIniciarVideo = 'TelemedicinaIniciarVideo',
    TelemedicinaGravar = 'TelemedicinaGravar',

    CertificadoDigitalRead = 'CertificadoDigitalRead',
    CertificadoDigitalCreate = 'CertificadoDigitalCreate',
    CertificadoDigitalUpdate = 'CertificadoDigitalUpdate',
    CertificadoDigitalDelete = 'CertificadoDigitalDelete',
    // J5 — LGPD: transparência de acessos (staff vê histórico de acessos do paciente).
    ConsentimentoAcessoRead = 'ConsentimentoAcessoRead',
}
export default PermissoesPadrao;
